(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!window.bffMobileMenuInit) {
    window.bffMobileMenuInit = true;

    document.addEventListener('DOMContentLoaded', () => {
      const menu = document.getElementById('mobile-menu');
      if (!menu) return;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-mobile-menu-open]')) {
          menu.showModal();
        }
        if (event.target.closest('[data-mobile-menu-close]')) {
          menu.close();
        }
      });

      menu.addEventListener('click', (event) => {
        if (event.target === menu) menu.close();
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
        this.variantInput = this.querySelector('[data-variant-id]');
        this.priceEl = this.querySelector('.price__amount');
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.submitLabel = this.querySelector('[data-add-to-cart-label]');
        this.gallery = this.querySelector('[data-product-gallery]');
        this.quantityStepper = this.querySelector('[data-quantity-stepper]');

        if (this.quantityStepper) {
          this.quantityStepper.addEventListener('click', (event) => this.handleQuantityClick(event));
        }

        this.selected = {};
        this.querySelectorAll('[data-option-value][aria-pressed="true"]').forEach((btn) => {
          this.selected[btn.dataset.optionIndex] = btn.dataset.value;
        });

        this.addEventListener('click', (event) => {
          const pill = event.target.closest('[data-option-value]');
          if (pill) this.selectOption(pill);
        });

        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      selectOption(pill) {
        const index = pill.dataset.optionIndex;
        this.selected[index] = pill.dataset.value;

        this.querySelectorAll(`[data-option-value][data-option-index="${index}"]`).forEach((btn) => {
          btn.setAttribute('aria-pressed', btn === pill ? 'true' : 'false');
        });

        this.applyVariant(this.findVariant());
      }

      handleQuantityClick(event) {
        const valueEl = this.quantityStepper.querySelector('[data-quantity-value]');
        const input = this.quantityStepper.querySelector('[data-quantity-input]');
        const min = Number(this.quantityStepper.dataset.min || 1);
        let value = Number(valueEl.textContent);

        if (event.target.closest('[data-quantity-increase]')) {
          value += 1;
        } else if (event.target.closest('[data-quantity-decrease]')) {
          value = Math.max(min, value - 1);
        } else {
          return;
        }

        valueEl.textContent = value;
        if (input) input.value = value;
      }

      findVariant() {
        const values = Object.keys(this.selected)
          .sort()
          .map((key) => this.selected[key]);
        return this.variants.find((variant) => variant.options.every((value, i) => value === values[i]));
      }

      applyVariant(variant) {
        if (!variant) {
          this.submitButton.disabled = true;
          return;
        }

        this.variantInput.value = variant.id;
        this.submitButton.disabled = !variant.available;
        this.submitLabel.textContent = variant.available
          ? this.submitLabel.dataset.addLabel
          : this.submitLabel.dataset.soldOutLabel;

        if (this.priceEl) {
          this.priceEl.textContent = this.formatMoney(variant.price);
        }

        if (variant.featured_image && this.gallery) {
          const target = this.gallery.querySelector(`[data-image-id="${variant.featured_image.id}"]`);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.dataset.currency,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      handleSubmit(event) {
        event.preventDefault();
        const quantityInput = this.form.querySelector('[data-quantity-input]');
        const quantity = quantityInput ? Number(quantityInput.value) : 1;

        this.submitButton.disabled = true;
        this.submitLabel.textContent = this.submitLabel.dataset.addingLabel;

        const reset = () => {
          this.submitButton.disabled = false;
          this.applyVariant(this.findVariant());
        };

        document.addEventListener('bff:cart:added', reset, { once: true });
        document.addEventListener('bff:cart:error', reset, { once: true });

        document.dispatchEvent(
          new CustomEvent('bff:cart:add', {
            detail: { id: Number(this.variantInput.value), quantity },
          })
        );
      }
    }

    customElements.define('product-form', ProductForm);
  }

  } catch(e) { console.error(e); }
})();
})();
